"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenAriaStatus = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var HiddenAriaStatus = _styledComponents.default.div.withConfig({
  displayName: "HiddenAriaStatus",
  componentId: "c8pmky-0"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;"]);

exports.HiddenAriaStatus = HiddenAriaStatus;